import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

const banner = () => {
        gsap.set('.banner img', {
            autoAlpha: 0,
        });

        const bannerTl = gsap.timeline({
            paused: true
        });

        bannerTl
            .to('.banner img', {
                autoAlpha: 1,
                ease: 'power1.inOut',
                duration: 0.8
            }, 0.2);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: '.banner',
            start: 'top bottom-=300',
            end: 'bottom top',
            animation: bannerTl,
            toggleActions: 'play none none none',
        });
};

export default banner;
